<template>
  <AboutUs/>
</template>

<script>
// @ is an alias to /src
import AboutUs from '@/components/AboutUs.vue';

export default {
  name: 'AboutUsView',
components: {
  AboutUs
  },
  data(){
    return{

    };
  }
}
</script>